import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: 'input[novaPointTwoFive]',
    standalone: true
})
export class PointTwoFiveDirective {
    private el: HTMLInputElement;

    constructor(private readonly elementRef: ElementRef) {
        this.el = this.elementRef.nativeElement;
    }

    @HostListener('blur', ['$event.target.value'])
    onBlur(value: string): void {
        this.el.value = this.transform(value);
    }

    private transform(value: string): string {
        const val = +value;
        if (value === '' || isNaN(val)) {
            return value;
        }
        if (val < 0.25) {
            return '0.25';
        }
        if (val > 24) {
            return '24.00';
        }
        return this.roundFloat(val, 0.25, 2);
    }

    private roundFloat(value: number, toNearest: number, fixed: number): string {
        return (Math.round(value / toNearest) * toNearest).toFixed(fixed);
    }
}
